import { ScreenAttributes } from 'core/flow/entities';
import ImagesPreloader from './ImagesPreloader';
import { ScreenPreloader } from './ScreenPreloader';

type DynamicPreloadersProps = {
  screenId: string;
  initialScreenId: string;
  screenAttributes: ScreenAttributes;
  nextScreenAttributes: ScreenAttributes | null;
};

export const DynamicPreloaders = ({
  screenId,
  initialScreenId,
  screenAttributes,
  nextScreenAttributes,
}: DynamicPreloadersProps) => {
  const isInitialScreen = initialScreenId === screenId;

  return (
    <>
      <ScreenPreloader
        isInitialScreen={isInitialScreen}
        screenType={screenAttributes.screenType}
        nextScreenType={nextScreenAttributes ? nextScreenAttributes.screenType : null}
      />
      <ImagesPreloader nextScreenId={screenAttributes.next} />
    </>
  );
};
